import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

/**
 * The gallery's shortcuts, opened with ? (the button or the key) from the gallery, the viewer or the
 * grid. It sits above all three and keeps the keyboard while open: Esc closes it, not what is behind.
 */
@Component({
  selector: 'app-gallery-help',
  templateUrl: './gallery-help.component.html',
  styleUrls: ['./gallery-help.component.scss'],
  standalone: false
})
export class GalleryHelpComponent implements OnInit, OnDestroy {
  /** Where it was opened from: that part is marked. */
  @Input() from: 'gallery' | 'viewer' | 'grid' = 'gallery';
  @Input() deletable = false;
  @Input() cardio = false;
  @Output() closed = new EventEmitter<void>();

  // On window, capturing: it runs before the viewer's and the grid's own keys and stops them.
  private onKey = (e: KeyboardEvent) => {
    e.stopPropagation();
    if (e.key === 'Escape' || e.key === '?') { e.preventDefault(); this.closed.emit(); }
  };

  ngOnInit(): void { window.addEventListener('keydown', this.onKey, true); }
  ngOnDestroy(): void { window.removeEventListener('keydown', this.onKey, true); }
}
